import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { WorkflowGuard }        from './workflow/workflow-guard.service';
import { WorkflowService }      from './workflow/workflow.service';

import { MainComponent }    from './main/main.component';
import { ArtHausComponent } from './art-haus/art-haus.component';
import { ArtWohnungComponent } from './art-wohnung/art-wohnung.component';
import { ArtHausStep2Component} from './art-haus-step2/art-haus-step2.component';
import { ArtHausStep3Component } from './art-haus-step3/art-haus-step3.component';
import { ArtHausStep4Component } from './art-haus-step4/art-haus-step4.component';
import { ArtHausStep5Component } from './art-haus-step5/art-haus-step5.component';
import { FinalComponent } from './final/final.component';
import { ArtWohnungStep2Component } from './art-wohnung-step2/art-wohnung-step2.component';
import { ArtWohnungStep3Component } from './art-wohnung-step3/art-wohnung-step3.component';
import { ArtWohnungStep4Component } from './art-wohnung-step4/art-wohnung-step4.component';
import { ArtWohnungStep5Component } from './art-wohnung-step5/art-wohnung-step5.component';

const routes: Routes = [

  { path: 'index',  component: MainComponent },

  { path: 'haus-step1',  component: ArtHausComponent },

  { path: 'haus-step2',  component:  ArtHausStep2Component },

  { path: 'haus-step3',  component:  ArtHausStep3Component },

  { path: 'haus-step4',  component:  ArtHausStep4Component },

  { path: 'haus-step5',  component:  ArtHausStep5Component },

  { path: 'wohnung-step1',  component: ArtWohnungComponent },

  { path: 'wohnung-step2',  component: ArtWohnungStep2Component },

  { path: 'wohnung-step3',  component: ArtWohnungStep3Component },

  { path: 'wohnung-step4',  component: ArtWohnungStep4Component },

  { path: 'wohnung-step5',  component: ArtWohnungStep5Component },

  { path: 'final',  component: FinalComponent },

  // 5th Route
  { path: '',   redirectTo: '/index', pathMatch: 'full' },
  // 6th Route
  { path: '**', component: MainComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
  providers: [WorkflowGuard]
})
export class AppRoutingModule { }
